import 'vant/lib/index.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  keyName: 'metaInfo', // 组件选项中 metaInfo 的名称 (default: metaInfo)
  tagIDKeyName: 'tagId', // 标签的 ID 名称（在文档中使用） (default: tagId)
  ssrAttribute: 'data-ssr', // SSR 渲染的元素属性名称 (default: data-ssr)
  tagPriority: 'priority', // 管理优先级（默认：数字）（default: priority）
  tagDuplicates: ['name', 'property'], // [string, RegExp]
  onChangeHead: function () {}
});
import {Button,DropdownMenu,DropdownItem,Cell,Switch,Field,Dialog,Popup,DatetimePicker} from 'vant'
import { RadioGroup, Radio } from 'vant';
import { CheckboxGroup, Checkbox } from 'vant';
import { Tab, Tabs } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NavBar, Icon, Tag } from 'vant';
import { Picker, CellGroup } from 'vant';

import { Toast } from 'vant'
// 全局提升 Toast 层级，避免被 z-index 较高的弹窗（如登录/绑定弹窗 9999）遮挡
Toast.setDefaultOptions({ zIndex: 20000 })

Vue.component('van-field', Field)
Vue.component('van-button', Button)
Vue.component('van-dropdown-menu', DropdownMenu)
Vue.component('van-dropdown-item', DropdownItem)
Vue.component('van-cell', Cell)
Vue.component('van-cell-group', CellGroup)
Vue.component('van-switch', Switch)
Vue.component('van-checkbox-group', CheckboxGroup)
Vue.component('van-checkbox', Checkbox)
Vue.component('van-radio-group', RadioGroup)
Vue.component('van-radio', Radio)
Vue.component('van-tab', Tab)
Vue.component('van-tabs', Tabs)
Vue.component('van-tabbar', Tabbar)
Vue.component('van-tabbar-item', TabbarItem)
Vue.component('van-nav-bar', NavBar)
Vue.component('van-icon', Icon)
Vue.component('van-tag', Tag)
Vue.component('van-popup', Popup)
Vue.component('van-datetime-picker', DatetimePicker)
Vue.component('van-picker', Picker)
Vue.component('van-dialog', Dialog.Component)
Vue.config.productionTip = false

function setViewportWidth() {
  document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth}px`)
}
setViewportWidth()
window.addEventListener('resize', setViewportWidth)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 获取哀悼模式状态
const MOURN_API_URL = process.env.VUE_APP_BASE_URL + '/api/index/getMournEnabled'
fetch(MOURN_API_URL).then(response => response.json()).then(data => {
  if (data.code === 200 && data.data === true) {
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.style.webkitFilter = 'grayscale(100%)'
      appElement.style.mozFilter = 'grayscale(100%)'
      appElement.style.msFilter = 'grayscale(100%)'
      appElement.style.oFilter = 'grayscale(100%)'
      appElement.style.filter = 'grayscale(100%)'
      appElement.style.filter = 'progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)'
    }
  }
}).catch(error => {
  console.error('获取哀悼模式状态失败:', error)
})
